import * as S from "./styles.ts";
import Link from "next/link";
import { Image } from "@template/components";
import { StaticImageData } from "next/image";

interface ICardCtaProps {
  image_src?: string | StaticImageData;
  image_alt?: string;
  label?: string;
  description?: string;
  url?: string;
}

const CardCta = ({
                   image_src,
                   image_alt,
                   label,
                   description,
                   url,
                 }: ICardCtaProps) => {
  return (
    <Link href={url || ""}>
      <S.CardCtaContainer>
        <S.CardCtaContentContainer>
          {image_src && (
            <Image
              src={image_src}
              alt={image_alt || label}
              style={{
                objectFit: "contain",
                width: "100%",
                height: "100%",
              }}
            />
          )}
          <S.TextContainer>
            {label && <S.Title>{label}</S.Title>}
            {description && <S.Description>{description}</S.Description>}
          </S.TextContainer>
        </S.CardCtaContentContainer>
      </S.CardCtaContainer>
    </Link>
  );
};

export default CardCta;
